import { Routes, Route, Navigate } from "react-router-dom"
import { useAuth } from "../../context/usercontext"

import SADashboard from "./dashboard"
import SchemeDashboard from "./scheme/dashboard"
import NewScheme from "./scheme/newScheme"
import ConsumerDashboard from "./consumer/consumerDashBoard"
import NewConsumer from "./consumer/newConsumer"
import ViewConsumer from "./consumer/viewConsumer"
import EditConsumer from "./consumer/editConsumer"
import BillDashboard from "./bill/dashboard"
import NewBill from "./bill/newBill"
import ViewBill from "./bill/viewBill"
import NewPayment from "./bill/newPayment"
import PaymentRecord from "./bill/paymentRecord"
import NewSchemeUser from "./scheme/newSchemeUser"
import EditSchemeUser from "./scheme/editSchemeUser"

const AdminRoutes = () => {
  const { user, loading } = useAuth()


  if (loading) return null  


  if (!user || user.role !== "admin") {
    return <Navigate to="/" replace />
  }

  return (
    <Routes>
      <Route path="dashboard" element={<SADashboard />} />
      <Route path="register-scheme" element={<NewScheme />} />
      <Route path="scheme/:id" element={<SchemeDashboard />} />

      <Route path="scheme/:id/consumers" element={<ConsumerDashboard />} />
      <Route path="scheme/:id/consumers/add-consumer" element={<NewConsumer />} />
      <Route path="scheme/:id/consumers/:consumer/edit" element={<EditConsumer />} />
      <Route path="scheme/:id/consumers/:consumer/view" element={<ViewConsumer />} />

      <Route path="scheme/:id/consumers/:consumer/bill" element={<BillDashboard />} />
      <Route path="scheme/:id/consumers/:consumer/bill/new-bill" element={<NewBill />} />
      <Route path="scheme/:id/consumers/:consumer/bill/:bill" element={<ViewBill />} />
      <Route path="scheme/:id/consumers/:consumer/bill/:bill/new-payment" element={<NewPayment />} />
      <Route path="scheme/:id/consumers/:consumer/bill/:bill/payments" element={<PaymentRecord />} />

      <Route path="scheme/:id/add-user" element={<NewSchemeUser />} />
      <Route path="scheme/:id/:user" element={<EditSchemeUser />} />
    </Routes>
  )
}

export default AdminRoutes
